// extracted by mini-css-extract-plugin
export default {"sections__container":"sections_sections__container__ohNtD","section__container":"sections_section__container__7mNM5","inViewRef":"sections_inViewRef__FTCvN"};